import React from "react";
import "./performance.css";
import { formatDate } from "../../../components/common/Converter";

function OpcrListPrint(object) {
  const performance = object?.performance || [];
  const employee =
    `${object?.assignedEmployee?.Firstname || ""} ${
      object?.assignedEmployee?.Middlename || ""
    } ${object?.assignedEmployee?.surname || ""}` || "";
  const supervisor = `${object?.supervisor?.Firstname || ""} ${
    object?.supervisor?.Middlename || ""
  } ${object?.supervisor?.surname || ""}`;

  const employeePosition =
    object?.assignedEmployee?.position?.position_title || "";
  // const supervisorPosition = object?.supervisor?.position?.position_title || "";

  const periodDate = `${formatDate(object?.periodFrom).toUpperCase() || ""} - ${
    formatDate(object?.periodTo).toUpperCase() || ""
  }`;
  const headingStyle = {
    fontWeight: "bold",
    margin: "0 0 5px 0",
  };

  const textStyle = {
    margin: "0px 0",
  };

  const tableHead = (title, width, span) => {
    return (
      <th
        style={{
          width: width,
          wordWrap: "break-word",
          padding: "5px",
          textAlign: "center",
          fontWeight: "bold",
        }}
        rowSpan={span}
      >
        {title}
      </th>
    );
  };

  return (
    <>
      <div style={{ margin: "30px" }}>
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          OFFICE PERFORMANCE COMMITMENT AND REVIEW (OPCR)
        </div>
        <div>
          <p style={{ textAlign: "justify" }}>
            I, <b>{employee}</b>, commit to deliver and agree to be rated on the
            attainment of the following targets in accordance with the indicated
            measures for the period of <b>{periodDate}</b>.
          </p>
        </div>
        <div style={{ textAlign: "right" }}>
          <p style={{ fontWeight: "bold", textDecoration: "underline" }}>
            {employee}
          </p>
          <p style={{ marginTop: "-13px" }}>{employeePosition}</p>
          <p style={{ marginTop: "-13px" }}>
            Date: {formatDate(object?.periodFrom)}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            margin: "2rem 10px",
          }}
        >
          <div
            style={{
              border: "1px solid black",
              width: "50%",
              padding: "5px",
            }}
          >
            <p style={headingStyle}>APPROVED BY:</p>
            <p style={textStyle}>
              <strong>Name:</strong> {object?.finalName}
            </p>
            <p style={textStyle}>
              <strong>Position:</strong> {object?.finalPosition}
            </p>
            <p style={textStyle}>
              <strong>Date: {formatDate(object?.createdAt)}</strong>
            </p>
          </div>
          {/* Column 2 */}
          <div style={{ marginRight: "4rem" }}>
            <div
              style={{
                border: "1px solid black",
                width: "170px",
                padding: "5px",
              }}
            >
              <p style={headingStyle}>Rating:</p>
              <p style={textStyle}>5-Outstanding</p>
              <p style={textStyle}>4-Very Satisfactory</p>
              <p style={textStyle}>3-Satisfactory</p>
              <p style={textStyle}>2-Unsatisfactory</p>
              <p style={textStyle}>1-Poor</p>
            </div>
          </div>
        </div>
        <div
          style={{
            margin: "-10px 10px 20px 10px", // Add margins to the entire content
          }}
        >
          <table
            border="1"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead
              style={{
                display: "table-row-group", // Ensures no special treatment for headers
              }}
            >
              <tr>
                {tableHead("Section Outcome", "", 2)}
                {tableHead("Success Indicators (Targets + Measures)", "", 2)}
                {tableHead("Allotted Budget", "", 2)}
                {tableHead("Actual Accomplishments", "", 2)}
                <th
                  colSpan="4"
                  style={{
                    width: "17%",
                    wordWrap: "break-word",
                    padding: "5px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                  rowSpan={1}
                >
                  Rating
                </th>
                {tableHead("Remarks", "", 2)}
              </tr>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Q
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  E
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  T
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  AVE.
                </th>
              </tr>
            </thead>
            <tbody>
              {performance.map((data, index) => (
                <tr
                  key={index}
                  style={{
                    pageBreakInside: "avoid", // Prevents rows from breaking across pages
                  }}
                >
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.unitoutcome}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      verticalAlign: "top",
                      textAlign: "left",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data?.successindicators?.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.allottedbudget}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data?.actualaccomplishments?.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.quality}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.efficiency}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.timeliness}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      textAlign: "center",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.average.toFixed(2)}
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "left",
                      verticalAlign: "top",
                    }}
                  >
                    {data?.remarks ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.remarks?.replace(/\n/g, "<br />"),
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  style={{
                    padding: "5px",
                    wordWrap: "break-word",
                    textAlign: "center",
                  }}
                  colSpan={7}
                >
                  TOTAL RATING
                </td>
                <td
                  style={{
                    padding: "5px",
                    wordWrap: "break-word",
                    textAlign: "center",
                  }}
                  colSpan={2}
                >
                  {performance
                    .reduce((sum, item) => sum + parseFloat(item.average), 0)
                    .toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: "5px",
                    wordWrap: "break-word",
                    textAlign: "center",
                  }}
                  colSpan={7}
                >
                  FINAL AVERAGE RATING
                </td>
                <td
                  style={{
                    padding: "5px",
                    wordWrap: "break-word",
                    textAlign: "center",
                  }}
                  colSpan={2}
                >
                  {performance
                    .reduce(
                      (sum, item) =>
                        sum + parseFloat(item.average) / performance.length,
                      0
                    )
                    .toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
          <p>The above rating has been discussed with:</p>
          <table
            border="1"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead></thead>
            <tbody>
              <tr>
                <td>
                  Name and Signature of Ratee: <b>{object?.headName}</b>
                </td>
                <td>
                  Name and Signature of Rater: <b>{object?.finalName}</b>
                </td>
              </tr>
              <tr>
                <td>Position: {object?.headPosition}</td>
                <td>Position: {object?.finalPosition}</td>
              </tr>

              <tr>
                <td>Date: {formatDate(object?.createdAt)}</td>
                <td>Date: {formatDate(object?.updatedAt)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default OpcrListPrint;
